import React from 'react';

const TenantNotFound: React.FC = () => (
  <div style={{
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#f8fafc',
    padding: 20,
    textAlign: 'center',
  }}>
    <div style={{
      maxWidth: 480,
      background: '#fff',
      padding: 40,
      borderRadius: 8,
      border: '1px solid #e5e7eb',
    }}>
      <h1 style={{ marginTop: 0, color: '#dc2626' }}>Prodavnica nije pronađena</h1>
      <p style={{ color: '#6b7280' }}>
        Adresa <strong>{window.location.host}</strong> ne pripada nijednoj aktivnoj prodavnici.
      </p>
      <p style={{ color: '#6b7280', fontSize: 13, marginTop: 24 }}>
        Ako mislite da je ovo greška, kontaktirajte podršku.
      </p>
    </div>
  </div>
);

export default TenantNotFound;
